import {IDictionary} from './idictionary.interface';

/**
 * Represents a collection of keys and values.
 */
export class Dictionary implements IDictionary {

    private _keys: string[] = new Array<string>();
    private _values: any[] = new Array<any>();

    /**
     * Initializes a new instance of the Dictionary class.
     * @param init: Collection of key value pairs to start the dictionary with.
     */
    constructor(init: { key: string; value: any }[]) {
        for (var x = 0; x < init.length; x++) {
            this[init[x].key] = init[x].value;
            this._keys.push(init[x].key);
            this._values.push(init[x].value);
        }
    }

    /**
     * Adds the specified key and value to the dictionary.
     * @param key: Key of the element to add.
     * @param value: The value of the element to add.
     */
    add(key: string, value: any) {
        this[key] = value;
        if (!this.containsKey(key)) {
            this._keys.push(key);
            this._values.push(value);
        } else {
            const index = this._values.findIndex(v => v === value);
            this._values[index] = value;
        }
    }

    /**
     * Removes the value with the specified key from the dictionary.
     * @param key: The key of the element to remove.
     */
    remove(key: string) {
        var index = this._keys.indexOf(key, 0);
        this._keys.splice(index, 1);
        this._values.splice(index, 1);

        delete this[key];
    }

    /**
     * Gets a collection containing the keys in the dictionary.
     * @returns: Collection containing the keys in the dictionary.
     */
    getKeys(): string[] {
        return this._keys;
    }

    /**
     * Gets a collection containing the values in the dictionary.
     * @returns: Collection containing the values in the dictionary.
     */
    getValues(): any[] {
        return this._values;
    }

    /**
     * Determines whether the dictionary contains the specified key.
     * @param key: The key to locate in the dictionary.
     * @returns: True if the dictionary contains an element with the specified key; otherwise, false.
     */
    containsKey(key: string) {
        if (typeof this[key] === 'undefined') {
            return false;
        } else if (this._keys.find(v => v === key)) {
            return true;
        }

        return false;
    }

    /**
     * Returns the self-referenced object;
     */
    toLookup(): IDictionary {
        return this;
    }
}
